import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificationAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './Dashboard.css';

const TYPE_ICONS = {
  booking_new: '🎉', booking_confirmed: '✅', booking_cancelled: '❌',
  booking_completed: '🎊', payment_received: '💰', payment_refunded: '💸',
  review_received: '⭐', review_reply: '💬', decorator_verified: '✅',
  decorator_featured: '⭐', dispute_raised: '⚠️', dispute_resolved: '✅',
  message_received: '💬', system: '📢'
};

export default function NotificationsPage() {
  const { setUnreadCount } = useAuth();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => { fetchNotifications(); }, [page]);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const { data } = await notificationAPI.getAll({ page, limit: 20 });
      setNotifications(data.notifications);
      setTotal(data.total);
      setUnreadCount(data.unreadCount);
    } catch (_) {}
    setLoading(false);
  };

  const markAllRead = async () => {
    await notificationAPI.markAllRead().catch(() => {});
    setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
    setUnreadCount(0);
    toast.success('Sab read ho gayi!');
  };

  const handleNotifClick = async (notif) => {
    if (!notif.isRead) {
      await notificationAPI.markRead(notif._id).catch(() => {});
      setNotifications(prev => prev.map(n => n._id === notif._id ? { ...n, isRead: true } : n));
      setUnreadCount(prev => Math.max(0, prev - 1));
    }
    if (notif.link) navigate(notif.link);
  };

  const deleteNotif = async (e, id) => {
    e.stopPropagation();
    await notificationAPI.delete(id).catch(() => {});
    setNotifications(prev => prev.filter(n => n._id !== id));
  };

  const timeAgo = (date) => {
    const diff = Math.floor((Date.now() - new Date(date)) / 1000);
    if (diff < 60) return 'Abhi';
    if (diff < 3600) return `${Math.floor(diff / 60)} min pehle`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} ghante pehle`;
    return new Date(date).toLocaleDateString('hi-IN');
  };

  return (
    <div className="page">
      <div className="container" style={{ maxWidth: 700, paddingTop: '40px' }}>
        <div className="d-flex justify-between align-center mb-4">
          <h2>🔔 Notifications</h2>
          <button className="btn btn-outline btn-sm" onClick={markAllRead}>Sab Read Karo</button>
        </div>

        {loading ? (
          <div className="spinner" />
        ) : notifications.length === 0 ? (
          <div className="empty-state"><div style={{fontSize:'3rem'}}>📭</div><h3>Koi notification nahi</h3></div>
        ) : (
          <div className="notif-full-list">
            {notifications.map(n => (
              <div key={n._id} className={`notif-full-item card ${!n.isRead ? 'unread-item' : ''}`} onClick={() => handleNotifClick(n)}>
                <div className="notif-icon">{TYPE_ICONS[n.type] || '📢'}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: n.isRead ? 500 : 700 }}>{n.title}</div>
                  <div style={{ color: '#666', fontSize: '0.88rem', marginTop: 4 }}>{n.message}</div>
                  <div style={{ color: '#aaa', fontSize: '0.78rem', marginTop: 6 }}>{timeAgo(n.createdAt)}</div>
                </div>
                {!n.isRead && <div className="unread-dot" />}
                <button className="delete-notif" onClick={(e) => deleteNotif(e, n._id)}>×</button>
              </div>
            ))}
          </div>
        )}

        {total > 20 && (
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 24 }}>
            <button className="btn btn-outline" disabled={page === 1} onClick={() => setPage(p => p - 1)}>Pehle</button>
            <button className="btn btn-outline" disabled={page * 20 >= total} onClick={() => setPage(p => p + 1)}>Agle</button>
          </div>
        )}
      </div>
    </div>
  );
}
